import { createSlice } from "@reduxjs/toolkit";
import { EditPrateProps } from "../types";

const initialState: EditPrateProps = {
  editPrateDtl: null,
};

const editPrateDtlReducer = createSlice({
  name: "barcodeProduct",
  initialState: initialState,
  reducers: {
    setEditPrateDtl(state, action) {
      return {
        ...state,
        editPrateDtl: action.payload,
      };
    },
  },
});

export default editPrateDtlReducer.reducer;

export const { setEditPrateDtl } = editPrateDtlReducer.actions;
